<template>
  <div class="seomain">
		<st-header
		  title="出库记录"
		  :back-able="true"
		>
		  <template slot="header-right">
				<span class="search-icon-span">
					<!-- <van-icon name="search" @click="showSearch = true"/> -->
				</span>
		  </template>
		</st-header>
   
    <div class="tab-content tab-content-list">
			<!-- 搜索 多行 -->
			<div class="keyword" v-if="showSearch">
			  <van-form @submit="submitKeyword">
			    <van-field v-model="searchData.order_code" label="单号" placeholder="请输入单号" />
			    <van-field v-model="searchData.sku" label="SKU" placeholder="SKU" />
			    <div :style="{ padding: '16px', backgroundColor: '#fff' }">
			      <van-button round block type="info" native-type="submit">搜 索</van-button>
			    </div>
			  </van-form>
				<div style="text-align: center;background-color: white;">
					<div style="margin: 0px 24px;border-top: 1.5px solid #52596e;">
						<span @click="showSearch = false" style="color: grey!important;font-size: 18px;font-weight: 900;padding: 0px 160px;">
							<van-icon name="arrow-up" />
						</span>
					</div>
					
				</div>
			</div>
			
      <div class="st-list-box pan-0" v-loading="loading">
        <van-list>
          <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
            <router-link :to="'/saleo/info/' + v.id" class="st-list-top">
              <div class="t-tit">{{ v.sales_order }}</div>
              <div class="t-status"></div>
            </router-link>
            <div class="st-list-main">
              <p>批次号：{{ v.batch }}</p>
              <p>SKU：</p>
							<div :class="skuShowAll[v.id] ? '' : 'sku-show-part'">
								<div class="sku-list-box" v-for="(vv, i) in v.list">
									<div>
										<div>{{ vv.sku }}</div>
										<div style="font-size: 12px;line-height: 12px;color:#6d4303;margin: -8px 0px 8px;text-align: left;">{{ vv.warehouse }}</div>
									</div>
									<div class="outstocknum">{{ vv.outstocknum }}</div>
								</div>
								<div class="sku-extend-btn" @click="openSku(v.id)">展开</div>
							</div>
							<p>操&nbsp;&nbsp;作&nbsp;人：{{ v.operater }}</p>
							<p>出库时间：{{ v.createtime_text }}</p>
							<p>备&emsp;&emsp;注：{{ v.remark }}</p>
            </div>
          </div>
        </van-list>
      </div>
      
    </div>
  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
export default {
  components: {
		"st-header": StHeader,
	},
  props: {},
  data() {
    return {
			skuShowAll: {},
			showSearch: false,
			searchData: {
				order_code: "",
				sku: "",
				id: "",
			},
			stlist: [],
    };
  },
  watch: {},
  computed: {},
	created() {
		this.init();
	},
  methods: {
    async get_st_list(e) {
      this.stlist = [];
      this.onLoad();
    },
    init() {
			this.searchData.id = this.$route.params.id;
			this.get_st_list();
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("saleo_activeIndex", value);
    },
    // 分页
    async onLoad() {
			this.loading = true;
			let params = this.searchData;
			// params['page'] = this.page;
      let result = await this.$post(this.$api.stGetFaHuoOutlog, params);

      if (result.data.length == 0) return (this.finished = true);
			result.data.forEach((item) => {
				if (item.list.length > 3) {
					this.skuShowAll[item.id] = false;
				} else {
					this.skuShowAll[item.id] = true;
				}
			});
      // 进行操作
      this.stlist.push(...result.data);
      // 操作完成
      this.loading = false;
    },
    
    goUrl(url) {
      this.$router.push(url);
      return;
    },
    
    onSearch(val) {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this.stlist = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
		// 展开sku列表
		openSku(id) {
			this.$set(this.skuShowAll, id, true);
			this.$forceUpdate();
		}
  },
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "销售出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
div {
	box-sizing: border-box;
}
.search-icon-span .van-icon {
	font-size: 24px!important;
	color: #1a89fa;
	margin: 8px 12px;
	font-weight: 900;
}
.keyword {
  position: sticky;
	top:90px;
  width: 100%;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 0px;
	position: relative;
	top:20px;
	
	.st-list {
		margin: 12px 24px;
		border-radius: 5px;
	}
}

/* 2行input  end */

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyl-btn.active {
  background: #677588;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #3c8dbc;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}
.st-diyl-btn.checkBy {
  background-color: #677588;
}

.sku-list-box {
	display: flex;
	justify-content: space-between;
	.outstocknum {
		color: #219ff3;
	}
}
.sku-extend-btn {
	display: none;
}
.sku-show-part {
	max-height: 120px;
	overflow: hidden;
	text-align: center;
	position: relative;
	.sku-extend-btn {
		display: block;
		position: absolute;
		bottom: 0px;
		width: 100%;
		font-size: 14px;
		color: #a38e8e;
		background-color: #dcdde0;
		border-radius: 3px;
		box-shadow: 2px 0px 16px;
	}
}
</style>
